
import React, { Component } from 'react'

export default class Timer extends Component {
	constructor(props) {
		super(props);
	}
	state = {

		hours:this.props.hours,
		minutes: this.props.minutes,
		seconds: this.props.seconds,
		totalSeconds: this.props.totalSeconds,
		total: 0
	}
	calculateLabor(){
		let hourlyRate=125;
		let total =0;
		let fifteenMinuteRate = hourlyRate/4;
		let minutes = this.state.totalSeconds/60;
		let mod = minutes % 15;
		let billMinutes = minutes - 60;
		if (billMinutes < 0){billMinutes=0}
		let billTimes = 0;
		if(mod > 7) {billTimes = Math.ceil(billMinutes / 15);}
		else{billTimes = Math.floor(billMinutes / 15);}
		let billable = (fifteenMinuteRate * billTimes)+hourlyRate;
		total =(billable).toFixed(2);
		this.setState({total:total});
	}
	componentDidMount() {
		this.calculateLabor()
		this.myInterval = setInterval(() => {
			const { seconds, minutes,hours } = this.state
			this.setState({totalSeconds: this.state.totalSeconds+1})
			if (seconds > 0|| seconds ===0) {
				this.setState({seconds: seconds + 1})
			}

			if(seconds ===59){
				if(minutes ===59){
					this.setState({seconds: 0, minutes: 0,hours:hours+1})
				}else{
					this.calculateLabor()
					this.setState({seconds: 0, minutes: minutes +1})
				}

			}

		}, 1000)
	}

	componentWillUnmount() {
		clearInterval(this.myInterval)
	}

	render() {
		const { hours,minutes, seconds,total} = this.state
		return (
			<h4>Time On Site: {hours<10?`0${hours}`:hours}:{minutes<10?`0${minutes}`:minutes}:{seconds < 10 ? `0${seconds}` : seconds}
			<span className={"text-danger"}> (${total})</span>
			</h4>


		)
	}
}
